/**
 * Common UI adjustments shared across views
 */
function applyCommonActions() {
  const filterMobile = $('#calendarMobileToggle');
  if (filterMobile.length) {
    filterMobile.text('Filter Options');
  }

  removeEmptyFilterGroups();
  observeLearnMoreButtons(); // idempotent observer
}

/**
 * Entry point: modifies events view
 */
function modifyEvents() {
  const eventsClass = $('body')
    .attr('class')
    ?.split(' ')
    .find((c) => c.startsWith('event-id-'));
  if (!eventsClass || !$('body').hasClass(eventsClass)) return;

  addBanner('events');
  modifyFilters(`.${eventsClass} #eventListing`, setDateFilterBehavior);
  removeEmptyFilterGroups(); // ensure empty groups are cleaned
  applyCommonActions();
}

/**
 * Entry point: modifies businesses view
 */
function modifyBusinesses() {
  const diningClass = $('body')
    .attr('class')
    ?.split(' ')
    .find((c) => c.startsWith('business-id-'));
  if (!diningClass || !$('body').hasClass(diningClass)) return;

  addBanner('business');
  updateDateDisplayForBusiness();
  modifyFilters(`.${diningClass} #businessListing`, (filterRow) => {
    addMapFilterButton(filterRow);
  });
  removeEmptyFilterGroups(); // after adding map buttons
  applyCommonActions();
}

/**
 * Inserts the correct banner depending on type
 */
function addBanner(type) {
  const bannerClass = type === 'events' ? 'events-banner' : 'bus-banner';
  $('.content').before(`<div class="${bannerClass} header-banner"></div>`);
}

/**
 * Updates the date display bar for business view
 */
function updateDateDisplayForBusiness() {
  $('.dateDisplayBar').text('Dine With Us');
}

/**
 * Generic filter modifier: applies shared updates,
 * then runs any extra actions (like setting date or adding map button)
 *
 * @param {string} containerSelector - CSS selector for the content container
 * @param {function} extraActions - optional callback with filterRow as arg
 */
function modifyFilters(containerSelector, extraActions) {
  const content = $(containerSelector);
  const filterRow = content.find('.filter-items');
  const filterView = filterRow.find('.viewContainer');

  normalizeFilterView(filterView);

  if (typeof extraActions === 'function') {
    extraActions(filterRow);
  }
}

/**
 * Normalizes the filter view:
 * - Keeps only the first child (title)
 * - Replaces the view text with "Filter By:"
 * - Ensures the view is visible
 *
 * @param {jQuery} filterView - The filter view container
 */
function normalizeFilterView(filterView) {
  filterView.children().not(':first').remove();
  filterView.find('.viewText').text('Filter By:');
  filterView.css('display', 'block');
}

/**
 * Initializes date filter behavior:
 * adds active class depending on selection
 *
 * @param {jQuery} filterRow - The row containing filters
 */
function setDateFilterBehavior(filterRow) {
  const dateFilterGroup = filterRow.find('.filter-group').has('#date-toggle');
  dateFilterGroup.addClass('date-filter-group');

  updateSelectedDateState();

  // Delegate click events for dynamic children
  $('#eventDateList').on('click', 'a', updateSelectedDateState);
  $('.date-filter-group').on('change', updateSelectedDateState);
}

/**
 * Updates active state of the selected date element
 */
function updateSelectedDateState() {
  const isDefault = $('#selectedDate').text() === 'Date';
  $('#selectedDate').toggleClass('item-selected', !isDefault);
}

/**
 * Removes filter groups that have no children
 */
function removeEmptyFilterGroups() {
  $('.filter-group').each((_, element) => {
    if ($(element).children().length === 0) {
      $(element).remove();
    }
  });
}

/**
 * Adds map filter button to empty filter groups
 *
 * @param {jQuery} filterRow - The row containing filters
 */
function addMapFilterButton(filterRow) {
  const emptyFilterGroups = filterRow.find('.filter-group').filter((_, element) => {
    return $(element).children().length === 0;
  });

  if (emptyFilterGroups.length === 0) return;

  emptyFilterGroups.each((_, el) => {
    const $group = $(el);
    const button = createMapViewButton();
    $group.append(button).addClass('filter-map');
    button.on('click', handleMapViewClick);
  });
}

/**
 * Creates a map view button element
 */
function createMapViewButton() {
  return $(`
    <div class="filter-control" tabindex="0" aria-label="Business Map View" viewmode="MapView" role="button">
      Near Me
      <svg xmlns="http://www.w3.org/2000/svg" height="17" width="17" viewBox="0 0 640 640">
        <path fill="#31397b" d="M128 252.6C128 148.4 214 64 320 64C426 64 512 148.4 512 252.6C512 371.9 391.8 514.9 341.6 569.4C329.8 582.2 310.1 582.2 298.3 569.4C248.1 514.9 127.9 371.9 127.9 252.6zM320 320C355.3 320 384 291.3 384 256C384 220.7 355.3 192 320 192C284.7 192 256 220.7 256 256C256 291.3 284.7 320 320 320z"/>
      </svg>
    </div>
  `);
}

/**
 * Handles click event on map view button
 */
function handleMapViewClick() {
  const mapView = $('.viewMode.divMapViewMode:first');
  mapView.trigger('click');
  $(this).addClass('active');

  $('.viewMode')
    .not('.divMapViewMode')
    .on('click', () => {
      $('.filter-map .filter-control').removeClass('active');
    });
}

/**
 * Observes DOM changes and ensures "Learn More" buttons and images stay consistent
 * Idempotent: does not create multiple observers
 */
let learnMoreObserver;
function observeLearnMoreButtons() {
  if (learnMoreObserver) return;

  const updateButtons = () => {
    $('.dayContainer a.button, .dayContainer a.moreInfoButton').each(function () {
      const $this = $(this);
      if ($this.text().trim() !== 'Learn More') {
        $this.text('Learn More');
      }
    });
  };

  const resizePictures = () => {
    $('.expandedViewEventImage img').each(function () {
      const $this = $(this);
      const src = $this.attr('src');
      if (!src || (src.includes('w=400') && src.includes('h=400'))) return;
      const newSrc = src.replace(/w=\d+/, 'w=400').replace(/h=\d+/, 'h=400');
      if (newSrc !== src) $this.attr('src', newSrc);
    });
  };

  const handleMutations = () => {
    updateButtons();
    resizePictures();
  };

  handleMutations();
  learnMoreObserver = new MutationObserver(handleMutations);
  learnMoreObserver.observe(document.body, { childList: true, subtree: true });
}

export { modifyEvents, modifyBusinesses };
